import { render, staticRenderFns } from "./RawMaterials.vue?vue&type=template&id=f8ef2316&"
import script from "./RawMaterials.vue?vue&type=script&lang=js&"
export * from "./RawMaterials.vue?vue&type=script&lang=js&"
import style0 from "./RawMaterials.vue?vue&type=style&index=0&id=f8ef2316&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports